import 'assets/css/index.css'
import ScrollToTop from 'components/ScrollToTop'
import { getAuthToken } from 'helpers/FetchHelper'
import PrivateLayout from 'layouts/PrivateLayout'
import PublicLayout from 'layouts/PublicLayout'
import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { addToken, removeToken } from 'services/Axios'
import { useGetFiatList, useGetTokenList } from 'services/swr/token'
import RouteList from './Routes'
import { isMobile } from 'react-device-detect'
import ModalMobileWarning from 'components/Modal/ModalMobileWarning'
import { APP_REQUIRE_MOBILE } from 'constants/index'
import DepositPage from './Wallet/DepositPage'
import DepositDetailPage from './Wallet/DepositDetailPage'
import WalletHistoryPage from './Wallet/WalletHistoryPage'
import ForgotPassword from './Auth/ForgotPassword'

const Home = lazy(() => import('./Home'))
const SignIn = lazy(() => import('./Auth/SignIn'))
const SignUp = lazy(() => import('./Auth/SignUp'))
const SendPage = lazy(() => import('./Send'))
const SendConfirmPage = lazy(() => import('./Send/SendConfirm'))
const TransactionPage = lazy(() => import('./Transaction'))
const TransactionDetail = lazy(() => import('./Transaction/TransactionDetail'))
const UserPage = lazy(() => import('./User'))
const BlogDetail = lazy(() => import('./Blogs/BlogDetail'))
const ReferralPage = lazy(() => import('./Referral'))
const CheckPage = lazy(() => import('./Check'))
const MerchantPage = lazy(() => import('./Merchant'))
// const MerchantCreateOrderPage = lazy(() => import('./Merchant/CreateOrder'))

export const isLogin = () => getAuthToken()

/* ---------------------------- WRAP ROUTE ---------------------------- */
const WrapRoute = ({ layout: Layout, component: Component, ...rest }) => {
  // Gọi hooks token + fiat
  useGetTokenList()
  useGetFiatList()

  const checkToken = isLogin()
  if (checkToken) addToken(checkToken)
  else removeToken()

  return <Layout {...rest}>{!isMobile && APP_REQUIRE_MOBILE ? <ModalMobileWarning /> : <Component />}</Layout>
}

/* ---------------------------- ROUTE VARIANTS ---------------------------- */
export const PublicRoute = (props) => <WrapRoute layout={PublicLayout} {...props} />
export const PrivateRoute = (props) => <WrapRoute layout={PrivateLayout} {...props} />

export const CheckRoute = ({ component: Component }) => {
  const checkToken = isLogin()
  if (checkToken) addToken(checkToken)
  else removeToken()

  return <Component />
}

/* ---------------------------- MAIN APP ---------------------------- */
function App() {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <ToastContainer theme='dark' />
        <Routes>
          {/* Public */}
          <Route path={RouteList.home} element={<PublicRoute component={Home} />} />
          <Route path={RouteList.signIn} element={<PublicRoute component={SignIn} />} />
          <Route path={RouteList.signUp} element={<PublicRoute component={SignUp} />} />
          <Route path={RouteList.forgotPassword} element={<PublicRoute component={ForgotPassword} />} />

          {/* Check route (ko cần gọi API token/fiat) */}
          <Route path={RouteList.check} element={<CheckRoute component={CheckPage} />} />

          {/* Private */}
          <Route path={RouteList.send} element={<PrivateRoute component={SendPage} />} />
          <Route path={RouteList.sendConfirm} element={<PrivateRoute component={SendConfirmPage} />} />
          <Route path={RouteList.transactions} element={<PrivateRoute component={TransactionPage} />} />
          <Route path={RouteList.transactionDetail} element={<PrivateRoute component={TransactionDetail} />} />
          <Route path={RouteList.profile} element={<PrivateRoute component={UserPage} />} />
          <Route path='/blog/:slug' element={<PrivateRoute component={BlogDetail} />} />
          <Route path={RouteList.referral} element={<PrivateRoute component={ReferralPage} />} />
          <Route path={RouteList.merchant} element={<PrivateRoute component={MerchantPage} />} />
          <Route path={RouteList.wallet} element={<PrivateRoute component={DepositPage} />} />
          <Route path={RouteList.deposit} element={<PrivateRoute component={DepositDetailPage} />} />
          <Route path={RouteList.walletHistory} element={<PrivateRoute component={WalletHistoryPage} />} />
          {/* <Route path={RouteList.merchantCreateOrder} element={<PrivateRoute component={MerchantCreateOrderPage} />} /> */}

          {/* Redirect */}
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
        <ScrollToTop />
      </BrowserRouter>
    </Suspense>
  )
}

export default App
